import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";

const routes: Routes = [
  {
    path: "home",
    loadChildren: () =>
      import("./home/home.module").then((m) => m.HomePageModule),
  },
  {
    path: "home/:param",
    loadChildren: () =>
      import("./home/home.module").then((m) => m.HomePageModule),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginPageModule),
  },
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full",
  }, 
  {
    path: "forgotPassword",
    loadChildren: () =>
      import("./forgot-password/forgot-password.module").then(
        (m) => m.ForgotPasswordPageModule,
      ),
  },
  {
    path: "myProfile",
    loadChildren: () =>
      import("./my-profile/my-profile.module").then(
        (m) => m.MyProfilePageModule,
      ),
  },
  {
    path: "payment/add",
    loadChildren: () =>
      import("./add-payment/add-payment.module").then(
        (m) => m.AddPaymentPageModule,
      ),
  },
  {
    path: "payment/edit/:id",
    loadChildren: () =>
      import("./add-payment/add-payment.module").then(
        (m) => m.AddPaymentPageModule,
      ),
  },
  {
    path: "myPayments",
    loadChildren: () =>
      import("./my-payments/my-payments.module").then(
        (m) => m.MyPaymentsPageModule,
      ),
  },
  {
    path: "changePassword",
    loadChildren: () =>
      import("./change-password/change-password.module").then(
        (m) => m.ChangePasswordPageModule,
      ),
  },
  {
    path: "servicesHistory",
    loadChildren: () =>
      import(
        "./all-service-history/services-history/services-history.module"
      ).then((m) => m.ServicesHistoryPageModule),
  },
  {
    path: "serviceDetails/:id",
    loadChildren: () =>
      import("./all-service-history/service-detail/service-detail.module").then(
        (m) => m.ServiceDetailPageModule,
      ),
  },
  {
    path: "lostFound",
    loadChildren: () =>
      import("./reports/lost-found/lost-found.module").then(
        (m) => m.LostFoundPageModule,
      ),
  },
  {
    path: "safety",
    loadChildren: () =>
      import("./reports/safety/safety.module").then((m) => m.SafetyPageModule),
  },
  {
    path: "contactUs",
    loadChildren: () =>
      import("./reports/contact-us/contact-us.module").then(
        (m) => m.ContactUsPageModule,
      ),
  },
  {
    path: "externalPayment",
    loadChildren: () =>
      import("./external-payment/external-payment.module").then(
        (m) => m.ExternalPaymentPageModule,
      ),
  },
  {
    path: "forgot-modal",
    loadChildren: () =>
      import("./modals/forgot-modal/forgot-modal.module").then(
        (m) => m.ForgotModalPageModule,
      ),
  },
  {
    path: "login-modal",
    loadChildren: () =>
      import("./modals/login-modal/login-modal.module").then(
        (m) => m.LoginModalPageModule,
      ),
  },
  {
    path: "verify-code-modal",
    loadChildren: () =>
      import("./modals/verify-code-modal/verify-code-modal.module").then(
        (m) => m.VerifyCodeModalPageModule,
      ),
  },
  {
    path: "email-exists-modal",
    loadChildren: () =>
      import("./modals/email-exists-modal/email-exists-modal.module").then(
        (m) => m.EmailExistsModalPageModule,
      ),
  },
  {
    path: "register",
    loadChildren: () =>
      import("./driver/register/register.module").then(
        (m) => m.RegisterPageModule,
      ),
  },
  {
    path: "earning-calculations-page",
    loadChildren: () =>
      import(
        "./earning-calculations-page/earning-calculations-page.module"
      ).then((m) => m.EarningCalculationsPagePageModule),
  },
  {
    path: "earning-calculations",
    loadChildren: () =>
      import(
        "./earning-calculations-page/earning-calculations-page.module"
      ).then((m) => m.EarningCalculationsPagePageModule),
  },
  {
    path: "inbox",
    loadChildren: () =>
      import("./inbox/inbox.module").then((m) => m.InboxPageModule),
  },
  {
    path: 'charge',
    loadChildren: () => import('./charge/charge.module').then( m => m.ChargePageModule)
  },
  {
    path: 'signature/:id',
    loadChildren: () => import('./signature/signature.module').then( m => m.SignaturePageModule)
  },
  {
    path: 'header',
    loadChildren: () => import('./header/header.module').then( m => m.HeaderPageModule)
  },
  {
    path: 'footer',
    loadChildren: () => import('./footer/footer.module').then( m => m.FooterPageModule)
  },
  {
    path: 'cardInformation',
    loadChildren: () => import('./card-information/card-information.module').then( m => m.CardInformationPageModule)
  },
  {
    path: 'addCard',
    loadChildren: () => import('./add-card/add-card.module').then( m => m.AddCardPageModule)
  },
  {
    path: 'login-modal-status',
    loadChildren: () => import('./modals/login-modal-status/login-modal-status.module').then( m => m.LoginModalStatusPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
